import { Col, Divider, Form, Input, InputNumber, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import {  formItemLayout, selectOptionsTypes } from '../../utils/constants';
import DynamicSelect from '../../components/common/dynamicSelect';
import { useState } from 'react';
import { rederOrderItemConditionsFields } from '../../utils/functions';

const NewOrderItemForm = ({ onFinish }: { onFinish: (values: any) => void }) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [formFieldsSelectedLabels, setFormFieldsSelectedLabels] = useState({});

    const onSelectOptionChange = (type: any, selectedOption: any) => {
        const propKey = `${type + 'Label'}`;
        setFormFieldsSelectedLabels(prev => ({ ...prev, [propKey]: selectedOption.label }));
    }

    const onSave = (values: any) => {
        const mergedData = { ...formFieldsSelectedLabels, ...values };
        onFinish(mergedData);
    }

    return (
        <Form
            id="newOrderItem"
            form={form}
            className='orderItemForm'
            layout="vertical"
            size='small'
            {...formItemLayout}
            onFinish={onSave}
        >
            <Row gutter={16}>   

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }}>
                    <Form.Item
                        label={t('order.material')}
                        name="material"
                        rules={[{ required: true, message: t('messages.requiredField') }]}
                    >
                        <DynamicSelect type={selectOptionsTypes.material} value={undefined} onChange={undefined} location={undefined} onSelectChange={onSelectOptionChange} />
                    </Form.Item>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }}>
                    <Form.Item
                        label={t('order.orderQuantity')}
                        name="orderQuantity"
                        rules={[{ required: true, message: t('messages.requiredField') }]}
                    >
                        <InputNumber min={0} style={{ width: "100%" }} precision={0} />
                    </Form.Item>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }}>
                    <Form.Item
                        label={t('order.plant')}
                        name="plant"
                    >
                        <DynamicSelect type={selectOptionsTypes.plant} value={undefined} onChange={undefined} location={undefined} onSelectChange={onSelectOptionChange} />
                    </Form.Item>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }}>
                    <Form.Item
                        label={t('order.storageLocation')}
                        name="storageLocation"
                    >
                        <DynamicSelect type={selectOptionsTypes.storageLocation} value={undefined} onChange={undefined} location={undefined} onSelectChange={onSelectOptionChange} />
                    </Form.Item>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }}>
                    <Form.Item
                        label={t('order.shippingPoint')}
                        name="shippingPoint"
                    >
                        <Input />
                    </Form.Item>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }}>
                    <Form.Item
                        label={t('order.hlItem')}
                        name="hlItem"
                    >
                        <Input />
                    </Form.Item>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }}>
                    <Form.Item
                        label={t('order.poDetails')}
                        name="poDetails"
                    >
                        <Input />
                    </Form.Item>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }}>
                    <Form.Item
                        label={t('order.enteredMaterial')}
                        name="enteredMaterial"
                    >
                        <Input />
                    </Form.Item>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 8 }}>
                    <Form.Item
                        label={t('order.materialType')}
                        name="materialType"
                    >
                        <DynamicSelect type={selectOptionsTypes.materialType} value={undefined} onChange={undefined} location={undefined} onSelectChange={onSelectOptionChange} />
                    </Form.Item>
                </Col>

            </Row>
            <Divider />

            {rederOrderItemConditionsFields([], "create", t)}

        </Form>
    );
}
export default NewOrderItemForm;